import React from 'react'
import { Box } from '@mantine/core'
import AppCard from './AppCard'
import AppText from './AppText'

type AuthShellProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
};

export default function AuthShell ({ title, subtitle, children }: AuthShellProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'var(--gs-bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24
      }}
    >
      <AppCard
        sx={{
          maxWidth: 420,
          width: '100%',
          background: 'var(--gs-surface)',
          border: '1px solid var(--gs-border)',
          borderRadius: 8,
          padding: 32
        }}
      >
        <Box sx={{ textAlign: 'center', marginBottom: 24 }}>
          <AppText
            component="span"
            sx={{
              fontFamily: 'Oswald, sans-serif',
              fontWeight: 700,
              fontSize: 24,
              color: 'var(--gs-text)'
            }}
          >
            {title}
          </AppText>
          {subtitle
            ? (
            <AppText
              sx={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: 12,
                color: 'var(--gs-muted)',
                marginTop: 4
              }}
            >
              {subtitle}
            </AppText>
              )
            : null}
        </Box>
        {children}
      </AppCard>
    </Box>
  )
}
